<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <b-card title="Scans">

    <!-- table -->
<template v-if="$isAdmin">
  <br />
    <b-button
      
        href='/scan/add'
        variant="primary"
      >
        + Add a scan
      </b-button>
<br /><br />

</template>
  <template v-if="$user.main_account==true && $active_account==null">
    <template v-for="sub_account,index in $user.sub_accounts">
      <b-row v-if="subscribed[index]">
        
        <b-col cols="6" md="6">
          <b-card  class="border" :title="sub_account.brand_name?sub_account.brand_name:sub_account.name">
            <div class="header-card">
              <div class="title-card">
                <img src="@/assets/images/folder_icon.svg" alt="scan" /> 
                <span>Scans processed
                  <br />
                  <span class="grey-title">
                    This month
                  </span>
                </span>
              </div>
              <template v-for="element in sub[index].subscription_type.subscription_elements">
                <div class="big-nb">
                  {{ total_scans[index] }} / {{ element.quota }}
                </div>
              </template>
            
            </div>
            <div class="footer-card">

            
              <b-button
                
                @click="$router.push('subscription')"
                variant="secondary"
              >
                + Expand the storage
              </b-button>
              <span>
                <span class="grey-title">Credits resets:</span> {{ scan_reset_date[index] }}
              </span>
            </div>
          </b-card>
        </b-col>
        <b-col cols="6" md="6">
          <b-card  class="border" :title="sub_account.brand_name?sub_account.brand_name:sub_account.name">
            <div class="header-card">
              <div class="title-card">
                <img src="@/assets/images/stats_icon.svg" alt="scan" /> 
                <span>Scan overage
                  <br />
                  <template v-for="element in sub[index].subscription_type.subscription_elements">
                    <span class="grey-title" v-if="element.counter_type == 'scans'">
                      {{ element.amount }}€ / scan
                    </span>

                  </template>
                 
                </span>
              </div>
              <template v-for="element in sub[index].subscription_type.subscription_elements">
              <div class="big-nb">
                +{{ overage_scans[index] * element.amount }}€
              </div>

            </template>
            </div>
            <div class="footer-card">
            <span></span>
              <span>
        
                <span class="grey-title"> Number of overage scans:</span> {{ overage_scans[index] }}
              </span>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </template>
  </template>

    <template v-else>
    <b-row v-if="subscribed">
      <b-col cols="6" md="6">
        <b-card  class="border">
          <div class="header-card">
            <div class="title-card">
              <img src="@/assets/images/folder_icon.svg" alt="scan" /> 
              <span>Scans processed
                <br />
                <span class="grey-title">
                  This month
                </span>
              </span>
            </div>
            <template v-for="element in sub.subscription_type.subscription_elements">
              <div class="big-nb">
                {{ total_scans }} / {{ element.quota }}
              </div>
            </template>
          </div>
          <div class="footer-card">

          
            <b-button
              
              @click="$router.push('subscription')"
              variant="secondary"
            >
              + Expand the storage
            </b-button>
            <span>
              <span class="grey-title">Credits resets:</span> {{ scan_reset_date }}
            </span>
          </div>
        </b-card>
      </b-col>
      <b-col cols="6" md="6">
        <b-card  class="border">
          <div class="header-card">
            <div class="title-card">
              <img src="@/assets/images/stats_icon.svg" alt="scan" /> 
              <span>Scan overage
                <br />
                <template v-for="element in sub.subscription_type.subscription_elements">
                  <span class="grey-title" v-if="element.counter_type == 'scans'">
                    {{ element.amount }}€ / scan
                  </span>

                </template>
              
              </span>
            </div>
            <template v-for="element in sub.subscription_type.subscription_elements">
              <div class="big-nb">
                +{{ overage_scans * element.amount }}€
              </div>

            </template>
            
            
          </div>
          <div class="footer-card">
           <span></span>
            <span>
      
              <span class="grey-title"> Number of overage scans:</span> {{ overage_scans }}
            </span>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-else-if="$user.is_demo==true">
      <b-col cols="12" md="12">
        <b-card  class="border">
          <div class="header-card">
            <div class="title-card">
              <img src="@/assets/images/folder_icon.svg" alt="scan" /> 
              <span>Scans processed
               
              </span>
            </div>
            <div class="big-nb">
              {{ $user.scan_count }} / {{ $user.scan_quota }}
            </div>
          </div>
       
        </b-card>
      </b-col>
      
    </b-row>
  </template>
<div class="custom-search d-flex justify-content-end">
  <br />
      <b-form-group>
        <div class="d-flex align-items-center search-input-container">
       
          <b-form-input
        
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block search-input"
          />
        </div>
      </b-form-group>
    </div>

    
    <vue-good-table
      :columns="$user.main_account==true && $active_account==null ? columnsMain : columns"
      :rows="scans"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
    
      <template v-if="props.row.user!=null"
        slot="table-row"
        slot-scope="props"
        
      >
        <span
          v-if="props.column.field === 'name'"
          class="text-nowrap"
        >
          <span class="text-nowrap">{{props.row.name}}</span>
        </span>
        <span v-else-if="props.column.field == 'user.name' " >
            <span v-if="props.row.brand_name!=null">
              {{ props.row.brand_name }}<br />
            </span>
            <span v-else>
            {{ props.row.user.name }} {{ props.row.user.surname }}
          </span>
       
        </span>
        <span v-else-if="props.column.field == 'action'">
         <div class="actions">
           <!--
            <b-button v-if="selectedScan && selectedScan==props.row.id"
              
              variant="success"
            >
              Scan sélectionné
            </b-button>
            <b-button v-else @click="selectScan(props.row.id)"
              
              variant="dark"
            >
              Sélectionner Scan
            </b-button>
            -->

            <b-button v-if="$user.optical_scan_measurements_access==true || $user.other_scan_measurements_access==true" variant="primary"  @click="$router.push({name:!$isAdmin ? 'scanReview': 'scanDetail', params: { id: props.row.id }})"
              
           
            >
              Details
            </b-button>
<!--
            <b-button class="btn-icon ml-1" variant="primary">
              <img :src="props.row.favorite ? require('@/assets/images/star_full.svg') : require('@/assets/images/star_empty.svg')" alt="trash" />
            </b-button>
          -->

            <b-button class="btn-icon ml-1"  variant="primary" v-b-modal.modal-danger @click="selectedItem=props.row.id">
              <img src="@/assets/images/trash.svg" alt="trash" />
            </b-button>

            
          </div>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Page 1 de
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> sur {{ props.total }} résultats </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="totalRows"
              v-model="currentPage"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
        <b-modal
          id="modal-danger"
          cancel-variant="outline-secondary"
          cancel-title="Non"
          ok-variant="danger"
          ok-title="Oui"
          @ok="deleteScan(selectedItem)"
          modal-class="modal-danger"
          centered
          title="Êtes-vous sûr ?"
        >
          <b-card-text>
            Attention, cette action est irréversible ! Êtes-vous sûr de vouloir supprimer ce scan ?
          </b-card-text>
        </b-modal>
      </template>
    </vue-good-table>

  </b-card>
</b-overlay>
</template>

<script>
import {BModal, BButton, BOverlay, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BRow, BCol } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { props } from 'vue-prism-component';

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BModal,
    BButton,
    BRow,
    BCol
  },
  data() {
    return {
      scans:[],
      selectedScan:localStorage.senseye_b2b_selected_scan,
      pageLength: 10,
      totalRows:0,
      currentPage:1,
      sub:null,
      dir: false,
      subscribed:false,
      subscription:null,
      loading:true,
      selectedItem:null,
      total_scans:0,
      overage_scans:0,
      scan_reset_date:null,
      columns: [
        {
          label: 'Client',
          field: 'name',
        },
        {
          label: 'Date',
          field: 'date',
          type:'date',
          dateInputFormat:'dd/MM/yyyy',
          formatFn: function (value) {
              return value != null ? value : null
          }
        },
        {
          label: 'Device',
          field: 'device_model',
        },
        //{
        //  label: 'Compte client',
        //  field: 'user.name',
        //},
         {
          label: 'Actions',
          field: 'action',
        },
      ],
      columnsMain: [
      {
          label: 'Account',
         field: 'user.name',
        },
        {
          label: 'Client',
          field: 'name',
        },
        {
          label: 'Date',
          field: 'date',
          type:'date',
          dateInputFormat:'dd/MM/yyyy',
          formatFn: function (value) {
              return value != null ? value : null
          }
        },
        {
          label: 'Device',
          field: 'device_model',
        },
        
         {
          label: 'Actions',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',

    }
  },
  computed: {
    activeAccount() {
      return this.$active_account
    },
  },
  watch: {
    activeAccount() {
      const wasNotFirstPage = this.currentPage !== 1
      this.currentPage = 1
      if (!wasNotFirstPage) {
        this.loadScansData()
      }
    },
    currentPage:async function(){
      this.loading=true
      let offset=this.currentPage*this.pageLength


      if(this.$user.main_account==true && this.$active_account==null)
      {
        if(this.searchTerm!='')
        {

          var request='?main_user='+localStorage.id_user_senseye_auth+'&keyword='+this.searchTerm+'&limit='+this.pageLength+'&offset='+offset+'&order=desc'
          
        }
        else
        {
          var request='?main_user='+localStorage.id_user_senseye_auth+'&limit='+this.pageLength+'&offset='+offset+'&order=desc'
          
        }
      }
      else 
      {
        if(this.$active_account==null)
        {
          var user_id=localStorage.id_user_senseye_auth
        }
        else
        {
          var user_id=this.$active_account.id
        }
        if(this.searchTerm!='')
        {

          var request='?user='+user_id+'&keyword='+this.searchTerm+'&limit='+this.pageLength+'&offset='+offset+'&order=desc'
          
        }
        else
        {
          var request='?user='+user_id+'&limit='+this.pageLength+'&offset='+offset+'&order=desc'
          
        }
      }
      
     

      var scans=await APIRequest.list_with_request('scans', request)
      this.scans=scans[0]
      this.totalRows=scans[1]
      this.loading=false
    },
    searchTerm:async function(){
      this.loading=true
      let offset=this.currentPage*this.pageLength

      if(this.$user.main_account==true && this.$active_account==null)
      {
        if(this.searchTerm!='')
        {

          var request='?main_user='+localStorage.id_user_senseye_auth+'&keyword='+this.searchTerm+'&limit='+this.pageLength+'&offset='+offset+'&order=desc'
          
        }
        else
        {
          var request='?main_user='+localStorage.id_user_senseye_auth+'&limit='+this.pageLength+'&offset='+offset+'&order=desc'
          
        }
      }
      else 
      {
        if(this.$active_account==null)
        {
          var user_id=localStorage.id_user_senseye_auth
        }
        else
        {
          var user_id=this.$active_account.id
        }
        if(this.searchTerm!='')
        {

          var request='?user='+user_id+'&keyword='+this.searchTerm+'&limit='+this.pageLength+'&offset='+offset+'&order=desc'
          
        }
        else
        {
          var request='?user='+user_id+'&limit='+this.pageLength+'&offset='+offset+'&order=desc'
          
        }
      }

      var scans=await APIRequest.list_with_request('scans', request)

      
      this.scans=scans[0]
      this.totalRows=scans[1]
      this.loading=false
    }
  },
  methods: {
    async loadScansData() {
      this.loading = true

      let offset = this.currentPage * this.pageLength
      if (this.$user.main_account == true && this.$active_account == null) {
        if (this.searchTerm != '') {
          var request = '?main_user=' + localStorage.id_user_senseye_auth + '&keyword=' + this.searchTerm + '&limit=' + this.pageLength + '&offset=' + offset + '&order=desc'
        } else {
          var request = '?main_user=' + localStorage.id_user_senseye_auth + '&limit=' + this.pageLength + '&offset=' + offset + '&order=desc'
        }
      } else {
        if (this.$active_account == null) {
          var user_id = localStorage.id_user_senseye_auth
        } else {
          var user_id = this.$active_account.id
        }
        if (this.searchTerm != '') {
          var request = '?user=' + user_id + '&keyword=' + this.searchTerm + '&limit=' + this.pageLength + '&offset=' + offset + '&order=desc'
        } else {
          var request = '?user=' + user_id + '&limit=' + this.pageLength + '&offset=' + offset + '&order=desc'
        }
      }

      var scans = await APIRequest.list_with_request('scans', request)

      this.scans = scans[0]
      this.totalRows = scans[1]

      if (this.$user.main_account == true && this.$active_account == null) {
        this.subscribed = []
        this.sub = []
        this.subscription = []
        this.total_scans = []
        this.overage_scans = []
        this.scan_reset_date = []
        for (let i = 0; i < this.$user.sub_accounts.length; i++) {
          let subscription = await APIRequest.list_with_request('subscriptions', '?user=' + this.$user.sub_accounts[i].id + '&status=active&order=desc')
          if (subscription[0].length > 0) {
            this.subscribed[i] = true

            let response = await APIRequest.get_request('get-subscription/' + subscription[0][0].stripe_id + '/' + subscription[0][0].customer_stripe_id)

            this.sub[i] = subscription[0][0]

            this.subscription[i] = response.data.data

            let scansCount = 0

            for (let j = 0; j < response.data.meter_event_summaries.data.length; j++) {
              scansCount += response.data.meter_event_summaries.data[j].aggregated_value
            }

            this.total_scans[i] = scansCount

            let scan_quota=0

            for(let j=0;j<this.sub[i].subscription_type.subscription_elements.length;j++)
            {
              if(this.sub[i].subscription_type.subscription_elements[j].counter_type == 'scans')
              {
                scan_quota=this.sub[i].subscription_type.subscription_elements[j].quota
              }
            }

            let overage_scans = scansCount - scan_quota


            if (overage_scans < 0) {
              overage_scans = 0
            }
            this.overage_scans[i] = overage_scans

            for (let j = 0; j < this.subscription[i].items.data.length; j++) {
              let item = this.subscription[i].items.data[j]

              if (item.plan.meter) {
                
                  this.scan_reset_date[i] = item.current_period_end

                  this.scan_reset_date[i] = this.formatDate(this.scan_reset_date[i])
                  this.subscription[i].subscription_type = item.plan
                
              }
            }
          } else {
            this.subscribed[i] = false
            this.sub[i] = null
            this.subscription[i] = null
            this.total_scans[i] = 0
            this.overage_scans[i] = 0
            this.scan_reset_date[i] = null
          }
        }
      } else {
        if (this.$active_account == null) {
          var user_id = localStorage.id_user_senseye_auth
        } else {
          var user_id = this.$active_account.id
        }
        let subscription = await APIRequest.list_with_request('subscriptions', '?user=' + user_id + '&status=active&order=desc')
        if (subscription[0].length > 0) {
          this.subscribed = true

          let response = await APIRequest.get_request('get-subscription/' + subscription[0][0].stripe_id + '/' + subscription[0][0].customer_stripe_id)

          this.sub = subscription[0][0]

          this.subscription = response.data.data

          let scansCount = 0

          for (let i = 0; i < response.data.meter_event_summaries.data.length; i++) {
            scansCount += response.data.meter_event_summaries.data[i].aggregated_value
          }

          this.total_scans = scansCount

          let scan_quota=0

          for(let i=0;i<this.sub.subscription_type.subscription_elements.length;i++)
          {
            if(this.sub.subscription_type.subscription_elements[i].counter_type == 'scans')
            {
              scan_quota=this.sub.subscription_type.subscription_elements[i].quota
            }
          }

          let overage_scans = scansCount - scan_quota

          if (overage_scans < 0) {
            overage_scans = 0
          }
          this.overage_scans = overage_scans

          for (let i = 0; i < this.subscription.items.data.length; i++) {
            let item = this.subscription.items.data[i]

            if (item.plan.meter) {
              
              this.scan_reset_date = item.current_period_end

              this.scan_reset_date = this.formatDate(this.scan_reset_date)
              this.subscription.subscription_type = item.plan
              
            }
          }
        } else {
          this.subscribed = false
          this.sub = null
          this.subscription = null
          this.total_scans = 0
          this.overage_scans = 0
          this.scan_reset_date = null
        }
      }
      this.loading = false
    },
    selectScan(id) {
      this.selectedScan=id
      localStorage.senseye_b2b_selected_scan=id
     
    },
    async deleteScan(id)
    {
      this.loading=true
      try {
        await APIRequest.delete('scans',id)
        let offset=this.currentPage*this.pageLength
        if(this.$user.main_account==true && this.$active_account==null)
      {
        if(this.searchTerm!='')
        {

          var request='?main_user='+localStorage.id_user_senseye_auth+'&keyword='+this.searchTerm+'&limit='+this.pageLength+'&offset='+offset+'&order=desc'
          
        }
        else
        {
          var request='?main_user='+localStorage.id_user_senseye_auth+'&limit='+this.pageLength+'&offset='+offset+'&order=desc'
          
        }
      }
      else 
      {
        if(this.$active_account==null)
        {
          var user_id=localStorage.id_user_senseye_auth
        }
        else
        {
          var user_id=this.$active_account.id
        }
        if(this.searchTerm!='')
        {

          var request='?user='+user_id+'&keyword='+this.searchTerm+'&limit='+this.pageLength+'&offset='+offset+'&order=desc'
          
        }
        else
        {
          var request='?user='+user_id+'&limit='+this.pageLength+'&offset='+offset+'&order=desc'
          
        }
      }

      var scans=await APIRequest.list_with_request('scans', request)
        this.scans=scans[0]
        this.totalRows--
        this.loading=false
       
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Le scan a été supprimé !',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        
      } catch (error) {
        console.log(error)
        this.loading=false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Une erreur est survenue.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        
      }
      
    },
    formatDate(timestamp){
      let date = new Date(timestamp * 1000); // conversion en millisecondes

      let jour = String(date.getDate()).padStart(2, '0');
      let mois = String(date.getMonth() + 1).padStart(2, '0'); // mois de 0 à 11
      let annee = date.getFullYear();

      let dateFormatee = `${jour}/${mois}/${annee}`;
      return dateFormatee
    },
  },
  
  async mounted() {
    await this.loadScansData()
  }
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
.actions
{
  display: flex;
  gap: 0px;
}
</style>
